import React from 'react';
import { Alert } from '@kajabi/sage-react';

import { useCheckout } from '../../context';

export const ExpiredSignupSourceAlert = () => {
  const {
    planInfo: { expired_message: text },
  } = useCheckout();

  if (text) {
    return <Alert color={Alert.COLORS.WARNING} description={text} small />;
  }

  return null;
};
